import React from 'react';
import { motion } from 'framer-motion';
import { FaWindows, FaApple, FaLinux } from 'react-icons/fa';
import { SiElectron, SiRust, SiPython } from 'react-icons/si';
import './Desktop.css';

const platforms = [
  {
    icon: <FaWindows />,
    name: 'Windows',
    desc: 'Полная поддержка Windows 10/11. MSI-инсталляторы, интеграция с системными уведомлениями и треем.',
    color: '#0078d4',
  },
  {
    icon: <FaApple />,
    name: 'macOS',
    desc: 'Нативный опыт на Mac. DMG-дистрибутив, поддержка Apple Silicon (M1/M2/M3), Dock-интеграция.',
    color: '#a0a0a0',
  },
  {
    icon: <FaLinux />,
    name: 'Linux',
    desc: 'AppImage, DEB и RPM пакеты. Поддержка Ubuntu, Debian, Fedora и других дистрибутивов.',
    color: '#f5a623',
  },
];

const frameworks = [
  { icon: <SiElectron />, name: 'Electron', desc: 'Web-технологии в desktop' },
  { icon: <SiRust />, name: 'Tauri', desc: 'Лёгкий и быстрый' },
  { icon: <SiPython />, name: 'Python', desc: 'Автоматизация и утилиты' },
];

export default function Desktop() {
  return (
    <section className="section desktop" id="desktop">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="tag">DESKTOP-РАЗРАБОТКА</div>
          <div className="section-divider" style={{ marginTop: 16 }} />
          <h2 className="section-title">
            Приложения для <span>любой платформы</span>
          </h2>
          <p className="section-subtitle">
            Разрабатываем кроссплатформенные desktop-приложения с единой кодовой базой 
            для Windows, macOS и Linux.
          </p>
        </motion.div>

        <div className="grid-3">
          {platforms.map((p, i) => (
            <motion.div
              key={i}
              className="desktop__platform card"
              style={{ '--platform-color': p.color }}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
            >
              <div className="desktop__platform-icon">{p.icon}</div>
              <h3 className="desktop__platform-name">{p.name}</h3>
              <p className="desktop__platform-desc">{p.desc}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="desktop__frameworks"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <p className="desktop__frameworks-label">Используемые технологии:</p>
          <div className="desktop__frameworks-list">
            {frameworks.map((f, i) => (
              <div key={i} className="desktop__fw">
                <span className="desktop__fw-icon">{f.icon}</span>
                <span className="desktop__fw-name">{f.name}</span>
                <span className="desktop__fw-desc">{f.desc}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
